import { Component } from '@angular/core';
import { AbstractInputDirective } from '../abstract-input/abstract-input.component';

@Component({
    selector: 'nom-select-input',
    templateUrl: './select-input.component.html',
    styleUrls: ['./select-input.component.scss'],
    standalone: false
})
export class SelectInputComponent extends AbstractInputDirective {

}
